$(document).ready(function(){

  $(document).on('click','.video-inner-cls .play-ico',function(){
    $(this).parents('.video-inner-cls').addClass('activated');
    $(this).parents('.video-inner-cls').find('.video-item-cls').get(0).play();
  })

  $(document).on('click','.video-inner-cls .hide-ico',function(){
    $(this).parents('.video-inner-cls').removeClass('activated');
    $(this).parents('.video-inner-cls').find('.video-item-cls').get(0).pause();
  })


$(document).on('click', '.img-txt-img-cls .play-ico, .img-txt-img-cls .cover-image', function(e) {
    e.preventDefault(); // Prevent default action of play button or iframe click
    var $parent = $(this).parents('.img-txt-img-cls');
    
    // Add 'activated' class to parent container
    $parent.addClass('activated');

    // Find the video link and append autoplay=1 if not already set
    var videoLink = $parent.find('.video-link');
    var videoHref = videoLink.attr('href');
    
    if (videoHref.indexOf('autoplay=1') === -1) {
        videoLink.attr('href', videoHref + (videoHref.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
    }
    
    // Trigger Fancybox manually to open the video
    $.fancybox.open({
        src  : videoLink.attr('href'),
        type : 'iframe',
        iframe : {
            preload : false // Disable preload to avoid issues
        }
    });
});




  
    $(document).on('click','.img-txt-img-cls .video-txt-item-cls',function(){
      if($(this).parents('.img-txt-img-cls').hasClass('activated')){
        $(this).parents('.img-txt-img-cls').removeClass('activated');
        // $(this).parents('.img-txt-img-cls').find('.video-txt-item-cls').get(0).pause();
      }
  })


  $(document).on('click','.tag-filter-cls .tag-item',function(){
    var handle = $(this).text().trim().toLowerCase().replace(/\s+/g, '-');
    console.log('handle',handle);
    if(handle != 'show-all'){
        window.location.href = '/blogs/news/tagged/'+handle;
    }else{
        window.location.href = '/blogs/news';
    };
  });

  window.onload = function() {
    if($('.tag-filter-cls .tag-item').length > 0){
        if (window.location.href.indexOf("/tagged") > -1) {
        var tagval = window.location.href.split('/tagged/')[1];
        $('.tag-filter-cls .tag-item').removeClass('active');
        $('.tag-filter-cls .tag-item').each(function() {
            var custag = $(this).attr('data-attr');
            if (tagval == custag) {
                $(this).addClass('active');
                console.log('Matched:', custag);
            }
        });
      }else{
        $('.tag-filter-cls .tag-item:last-child').addClass('active');
      }
    }
  }

  $(document).on('click','.collection-toolbar_item a.js-toggle-sb',function(e){
    e.preventDefault();
    $('.custom-static-sidebar').toggleClass('active');
    $('.collection-main-cls').toggleClass('filter-active');
    $('.collection-title .js-btn-close').toggleClass('active');
    $('html, body').animate({
      scrollTop: $(".custom-static-sidebar #sidebarDrawer").offset().top - 40
    }, 1000);
        var currentUrl = window.location.href;
    if (currentUrl.includes('filter.v')) {
        var resetBtn = document.querySelector('.custom_main_reset_btn');
        if (resetBtn) {
            resetBtn.classList.remove('d-none');
        }
    }
  })

  $(document).on('click','.collection-title .js-btn-close , #sidebarDrawer .sidebarDrawer-close',function(e){
    e.preventDefault();
    $('.custom-static-sidebar').toggleClass('active');
    $('.collection-main-cls').toggleClass('filter-active');
    $('.collection-title .js-btn-close').toggleClass('active');
  })

  $(document).on('click','.page-blog .page_wrapper .btn-more',function(){
    $('.blog-slider-bottom-cls').siblings('.col-3').find('#sidebarDrawer').toggleClass('is-open');
  })
  
  $(document).on('click','.template-blog #sidebarDrawer .sidebarDrawer-close',function(){
    $('.blog-slider-bottom-cls').siblings('.col-3').find('#sidebarDrawer').toggleClass('is-open');
  })
  
})




